import React, { useState } from "react";
import { Link } from 'react-router-dom';
import logo from "../../assets/images/bluesky-vue-logo.png";
import classnames from "classnames";
import LinearProgress from "@material-ui/core/LinearProgress";
import TextField from "@material-ui/core/TextField";
import { forgotPassword } from "../../services";

var { version: appVersion } = require("../../../package.json");

export const ForgotPassword = props => {
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState("");
  const [submissionComplete, setSubmissionComplete] = useState(false);

  const attemptForgotPassword = async (evt, username) => {
    evt.preventDefault();
    setLoading(true);
    setLoadError("");
    try {
      await forgotPassword(username);

      setLoading(false);
      setSubmissionComplete(true);
    } catch (error) {
      setLoading(false);
      setLoadError("Something went wrong, please try again");
    }
  };
  
  // todo jmf the full screen blue sky logo + some other stuff on the right could be its own component
  return (
    <div className={classnames("app", "login-background", "col-center-center")}>
      <div className={classnames("login-card", "row-between-center")}>
        <div className={classnames("login-card-left", "col-center-center")}>
          <img
            src={logo}
            alt={"BlueSky Vue Logo"}
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
        <div className={classnames("login-card-right", "col-center-center")}>
          <div
            style={{
              marginBottom: 10,
              fontWeight: "bold",
              fontSize: 28,
              color: "var(--jmi-blue)"
            }}
          >
            FORGOT PASSWORD
          </div>
          { submissionComplete ?
            <div
              style={{ marginTop: 20 }}
              className={classnames("col-center-center", "full-width")}
            >
              <div style={{ color: "#00cc" }}>If your username was valid, a password reset link will be sent to the email associated with your account.</div>
              <Link className="forgot-password-label" to={`/login`}>
                Back to Login
              </Link>
            </div>
            :
            <form
              id="forgot-password-form"
              style={{ width: "90%" }}
              onSubmit={evt => attemptForgotPassword(evt, username)}
            >
              <div className="col-start-start">
                <label>User Name <span style={{ fontStyle: 'italic', fontSize: 'small' }}>(this may be different than your email)</span></label>
                <TextField
                  value={username}
                  margin="dense"
                  variant="outlined"
                  inputProps={{ "aria-label": "bare" }}
                  style={{ width: "100%" }}
                  onChange={evt => setUsername(evt.target.value)}
                />
              </div>
              <div
                className={classnames("col-start-start")}
                style={{ marginTop: 20 }}
              >
              </div>
              <div
                style={{ marginTop: 20 }}
                className={classnames("row-between-center", "full-width")}
              >
                <Link className="forgot-password-label" to={`/login`}>
                  Back to Login
                </Link>
                <button type="submit" className="login-submit-button">
                  Submit
                </button>
              </div>
            </form>
          }

          <div
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              marginTop: 10,
              marginBottom: 25,
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div
              style={{
                width: "90%"
              }}
            >
              {loadError && <div style={{ color: "#c33" }}>{loadError}</div>}
              {loading && <LinearProgress />}
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 25, color: "#aaa", fontSize: 14 }}>
        Version {appVersion}
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {};
